import React from 'react'
import classes from "./styles.module.scss";
import SvgIcon from '../../../../components/SvgIcon';
import { IconNames } from '../../../../components/SvgIcon';

export interface TraitCardProps extends React.InputHTMLAttributes<HTMLInputElement> {
  image: string;
  icon: IconNames;
  title: string;
  text: string;
}

const TraitCard: React.FC<TraitCardProps> = ({ image, icon, title, text}) => {
  return (
    <div className={classes.TraitCard}>
      <div className={classes.upperSide}>
        <img src={image} alt="Trait" className={classes.traitImage} />
      </div>
      <div className={classes.lowerSide}>
        {icon && <SvgIcon name={icon} className={classes.icon} />}
        <h3 className={classes.cardTitle}>{title}</h3>
        <p className={classes.cardText}>{text}</p>
      </div>
    </div>
  )
}

export default TraitCard